<div class="parametro-page ds-page" (click)="fecharDropdown()">
  <main class="ds-page-content">

    <!-- ── HEADER ── -->
    <header class="ds-page-header">
      <div class="ds-page-header-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="3"/>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
        </svg>
      </div>
      <div class="ds-page-header-copy">
        <h1 class="ds-page-title">Parâmetros do Sistema</h1>
        <p class="ds-page-subtitle">Configurações usadas pelas telas de venda (ex.: ALTCOT, FABNAC)</p>
      </div>
      <div class="ds-page-actions">
        <button type="button" class="bt-novo" (click)="abrirNovo()">Novo Parâmetro</button>
      </div>
    </header>

    <!-- ── ALERTAS ── -->
    <div *ngIf="erro"    class="ds-alert ds-alert--danger">{{ erro }}</div>
    <div *ngIf="sucesso" class="ds-alert ds-alert--success">{{ sucesso }}</div>

    <!-- ── ETIQUETAS POR TELA ── -->
    <section class="ds-card ds-mb-3" *ngIf="!carregando">
      <div class="ds-card-header">
        <h2 class="ds-card-title">Etiquetas disponíveis por tela</h2>
      </div>
      <p class="ds-text-muted ds-mb-3">Escolha quais etiquetas cadastradas (tela de Configuração de Etiquetas) aparecem pra impressão em cada tela do sistema.</p>

      <div *ngIf="erroEtiquetasTela" class="ds-alert ds-alert--danger ds-mb-3">{{ erroEtiquetasTela }}</div>
      <div *ngIf="sucessoEtiquetasTela" class="ds-alert ds-alert--success ds-mb-3">{{ sucessoEtiquetasTela }}</div>

      <div class="ds-field" style="max-width:420px">
        <label class="ds-label">Tela</label>
        <select class="ds-select" [(ngModel)]="telaEtiquetaSelecionada">
          <option *ngFor="let tela of telasComEtiquetas" [value]="tela.chave">{{ tela.label }}</option>
        </select>
      </div>

      <div *ngIf="etiquetasCadastradas.length === 0" class="ds-empty-state">
        Nenhuma etiqueta cadastrada ainda (cadastre em Configuração de Etiquetas).
      </div>

      <div class="param-etiquetas-lista" *ngIf="etiquetasCadastradas.length > 0">
        <label class="ds-checkbox-label" *ngFor="let et of etiquetasCadastradas">
          <input type="checkbox" class="ds-checkbox"
            [checked]="etiquetaMarcada(et.codconfig)"
            (change)="toggleEtiquetaMarcada(et.codconfig)">
          {{ et.nome }}
        </label>
      </div>

      <div class="ds-mt-3" *ngIf="etiquetasCadastradas.length > 0">
        <button type="button" class="bt-salvar" [class.bt-carregando]="salvandoEtiquetasTela"
          [disabled]="salvandoEtiquetasTela" (click)="salvarEtiquetasTela()"><app-loading-indicator *ngIf="salvandoEtiquetasTela" size="inline"></app-loading-indicator>
          {{ salvandoEtiquetasTela ? 'Salvando...' : 'Salvar etiquetas desta tela' }}
        </button>
      </div>
    </section>

    <!-- ── TABELA ── -->
    <section class="ds-card">
      <div *ngIf="carregando" class="ds-loading-state">
        <app-loading-indicator></app-loading-indicator>
        <span>Carregando...</span>
      </div>

      <div *ngIf="!carregando && parametros.length === 0 && !erro" class="ds-empty-state">
        Nenhum parâmetro cadastrado.
      </div>

      <div class="ds-table-container" *ngIf="!carregando && parametros.length > 0" (scroll)="fecharDropdown()">
        <table class="ds-table ds-table--sticky-header">
          <thead>
            <tr>
              <th class="col-cod">Código</th>
              <th class="col-mod">Nome</th>
              <th>Valor</th>
              <th>Descrição</th>
              <th class="ds-text-center">Ativo</th>
              <th class="col-data">Criação</th>
              <th class="col-usuario">Usuário</th>
              <th class="ds-table-cell--actions">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of parametros">
              <td class="ds-text-muted">{{ p.codigo }}</td>
              <td><code class="param-nome-code">{{ p.nome }}</code></td>
              <td>{{ p.valor }}</td>
              <td class="ds-text-muted">{{ p.descricao || '—' }}</td>
              <td class="ds-text-center">
                <span class="ds-badge" [ngClass]="ativoClass(p.ativo)">{{ labelAtivo(p.ativo) }}</span>
              </td>
              <td class="ds-text-muted ds-nowrap">{{ p.dataCriacao || '—' }}</td>
              <td class="ds-text-muted ds-nowrap">
                <span *ngIf="p.codusu">{{ p.codusu }} — {{ p.nomeUsuario || '?' }}</span>
                <span *ngIf="!p.codusu">—</span>
              </td>
              <td class="ds-table-cell--actions" (click)="$event.stopPropagation()">
                <div class="ds-dropdown">
                  <button class="btn-dots"
                    [class.btn-dots-ativo]="dropdownAberto === p.codigo"
                    [disabled]="alterando === p.codigo"
                    (click)="toggleDropdown($event, p.codigo)"
                    title="Ações">
                    <span *ngIf="alterando !== p.codigo">⋮</span>
                    <app-loading-indicator *ngIf="alterando === p.codigo" size="inline"></app-loading-indicator>
                  </button>
                  <div class="ds-dropdown-menu ds-dropdown-menu--flutuante" *ngIf="dropdownAberto === p.codigo"
                    [style.position]="'fixed'" [style.top.px]="dropdownPos?.top" [style.right.px]="dropdownPos?.right">
                    <button class="ds-dropdown-item" (click)="abrirEditar(p)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                      </svg>
                      Editar
                    </button>
                    <div class="param-dropdown-divider" *ngIf="proximoAtivo(p)"></div>
                    <button class="ds-dropdown-item"
                      *ngIf="proximoAtivo(p)"
                      (click)="alterarAtivo(p, proximoAtivo(p))">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M18.36 6.64A9 9 0 1 1 5.64 17.36"/>
                        <polyline points="23 12 20 9 17 12"/>
                      </svg>
                      Mudar para: {{ proximoAtivo(p) }}
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="param-rodape" *ngIf="!carregando && parametros.length > 0">
        {{ parametros.length }} parâmetro{{ parametros.length !== 1 ? 's' : '' }} cadastrado{{ parametros.length !== 1 ? 's' : '' }}
      </div>
    </section>

  </main>
</div>

<!-- ── MODAL FORMULÁRIO ── -->
<div class="ds-modal-overlay" *ngIf="modalAberto" (click)="fecharModal()">
  <div class="ds-modal ds-modal--sm" (click)="$event.stopPropagation()">

    <div class="ds-modal-header">
      <h2 class="ds-modal-title">{{ modoEdicao ? 'Editar Parâmetro' : 'Novo Parâmetro' }}</h2>
      <button type="button" class="ds-modal-close" (click)="fecharModal()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <div class="ds-modal-body">
      <div *ngIf="erroForm" class="ds-alert ds-alert--danger ds-mb-3">{{ erroForm }}</div>

      <div class="ds-form">
        <div class="ds-field">
          <label class="ds-label ds-label-obrigatorio">Nome</label>
          <input type="text" class="ds-input" [(ngModel)]="form.nome"
            placeholder="Ex.: ALTCOT" maxlength="30" [disabled]="modoEdicao" style="text-transform:uppercase">
        </div>

        <div class="ds-field">
          <label class="ds-label ds-label-obrigatorio">Valor</label>
          <input type="text" class="ds-input" [(ngModel)]="form.valor"
            placeholder="Ex.: 5  ou  70,71,72" maxlength="200">
        </div>

        <div class="ds-field">
          <label class="ds-label">Descrição</label>
          <input type="text" class="ds-input" [(ngModel)]="form.descricao"
            placeholder="Pra que serve este parâmetro" maxlength="200">
        </div>

        <div class="ds-field">
          <label class="ds-label ds-label-obrigatorio">Ativo</label>
          <select class="ds-select" [(ngModel)]="form.ativo">
            <option value="">Selecione...</option>
            <option *ngFor="let op of opcoesAtivo" [value]="op">{{ op }}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="ds-modal-footer">
      <button type="button" class="bt-cancelar" (click)="fecharModal()">Cancelar</button>
      <button type="button" class="bt-salvar" [class.bt-carregando]="salvando" (click)="salvar()" [disabled]="salvando"><app-loading-indicator *ngIf="salvando" size="inline"></app-loading-indicator>
        {{ salvando ? 'Salvando...' : (modoEdicao ? 'Salvar alterações' : 'Cadastrar') }}
      </button>
    </div>
  </div>
</div>
